"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _lodash = require("lodash");

var isLegacyEntityLoading = function isLegacyEntityLoading(entity) {
  return entity.getData().isLoading;
};

var isDataUrl = function isDataUrl(src) {
  return (0, _lodash.startsWith)(src, 'data:');
};

var isUploadingImage = function isUploadingImage(entity) {
  var _entity$getData = entity.getData(),
      src = _entity$getData.src;

  return entity.getType() === 'wix-draft-plugin-image' && (!src || isDataUrl(src));
};

var isUploadingVideo = function isUploadingVideo(entity) {
  if (entity.getType() !== 'wix-draft-plugin-video') {
    return false;
  }

  var data = entity.getData();
  var hasOembed = (0, _lodash.has)(data, 'metadata.oembed');
  var hasCustomVideo = (0, _lodash.has)(data, 'src.pathname');
  var hasNewCustomVideo = (0, _lodash.has)(data, 'src') && (0, _lodash.get)(data, 'tempData') === false;
  return !(hasOembed || hasCustomVideo || hasNewCustomVideo);
};

var isUploadingGalleryItem = function isUploadingGalleryItem(item) {
  return (0, _lodash.get)(item, 'url', 'base64').includes('base64');
};

var isUploadingGallery = function isUploadingGallery(entity) {
  return entity.getType() === 'wix-draft-plugin-gallery' && (!(0, _lodash.get)(entity.getData(), 'items.length', 0) || (0, _lodash.some)(entity.getData().items, isUploadingGalleryItem));
};

var hasActiveUploads = function hasActiveUploads(contentState) {
  return contentState.getBlockMap().filter(function (block) {
    return block.getType() === 'atomic';
  }).map(function (block) {
    return block.getEntityAt(0);
  }).filter(_lodash.identity).toSetSeq().some(function (entityKey) {
    var entity = contentState.getEntity(entityKey);
    return isLegacyEntityLoading(entity) || isUploadingImage(entity) || isUploadingGallery(entity) || isUploadingVideo(entity);
  });
};

var _default = hasActiveUploads;
exports["default"] = _default;